import React from 'react';
import FaqSection from 'components/FaqSection';
import GuideSection from 'components/GuideSection';
import Link from 'next/link';
import SideBar from './SideBar';
import {
    HeaderH2,
    HeaderH1,
    Text,
    NextButton,
    ImageBlock
} from 'components/TextBlocks';

function ManageAccount(props) {
    return (
        <>
            <HeaderH1>Manage account</HeaderH1>
            <Text>
                After you have created a account you can change your username in
                the app by clicking the name. Apply and save by pressing enter
                or tapping outside the input field.
            </Text>
            <ImageBlock
                src={'/guide/edit_name.png'}
                width={504}
                height={463}
                alt={'Change username'}
            />
            <Text>
                To change Email, password or see billing info tap Manage
                account. Alternatively login to your account{' '}
                <Link href="/auth/login">here</Link> and go to{' '}
                <Link href="/settings/general">settings</Link> under account.
            </Text>
            <NextButton
                cta={'The Popover'}
                textColor={'#565D65'}
                bg={'#EBECED'}
                page={'/guide/popover'}
            />
        </>
    );
}

ManageAccount.Layout = SideBar;

export default ManageAccount;
